import React, { FC } from 'react';
import { useExperiments } from '@wix/yoshi-flow-editor';
import classNames from 'classnames';

import {
  Experiments,
  InjectedClassNameProps,
  InjectedDataHookProps,
} from '../../../types';
import styles from './RepositionButton.scss';
import { RepositionIcon } from './RepositionIcon';

type InjectedProps = InjectedClassNameProps & InjectedDataHookProps;

interface RepositionButtonProps extends InjectedProps {
  text: string;
  onClick?: () => void;
}

export const RepositionButton: FC<RepositionButtonProps> = ({
  dataHook,
  className,
  text,
  onClick,
}) => {
  const { experiments } = useExperiments();
  const isUiTpaImageEnabled = experiments.enabled(Experiments.UiTpaImage);

  return (
    <button
      data-hook={dataHook}
      className={classNames(styles.button, className)}
      onClick={onClick}
    >
      {isUiTpaImageEnabled ? <RepositionIcon /> : <i className={styles.icon} />}
      <span className={styles.text}>{text}</span>
    </button>
  );
};
